(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/navigation-back/assets/javascripts/navigation-back.js') >= 0) return;  svs.modules.push('/components/tur/navigation-back/assets/javascripts/navigation-back.js');
"use strict";


const {
  ReactIcon: Icon
} = svs.ui;
const {
  matchPath
} = ReactRouterDOM;
const IconButton = svs.ui.ReactIconButton;
setGlobal('svs.tur.navigationBack.logger', new svs.core.log.Logger('navigation-back'));

const NavigationBack = _ref => {
  let {
    routes,
    breadcrum,
    brand = 'tur'
  } = _ref;
  let match, found;
  const {
    pathname
  } = ReactRouterDOM.useLocation();
  const returnUrlParam = svs.utils.paramHandler.get({
    key: 'returnUrl'
  }).value;
  const returnUrl = returnUrlParam && decodeURIComponent(returnUrlParam);
  for (const path in routes) {
    found = matchPath(returnUrl, {
      path,
      exact: true
    });
    if (!found) {
      found = matchPath(pathname, {
        path,
        exact: true
      });
    }
    if (found) {
      match = routes[path];
      svs.tur.navigationBack.logger.debug("url match found for ".concat(path, " display text '").concat(routes[path].text, "'"));
      break;
    }
  }
  if (!match) {
    svs.tur.navigationBack.logger.debug("no match found for ".concat(returnUrl ? returnUrl : pathname));
    return React.createElement(React.Fragment, null);
  }
  const backPath = typeof match.path === 'function' ? match.path() : match.path;
  const handleOnClick = () => {
    if (typeof match.navigate === 'function') {
      match.navigate();
    } else {
      svs.utils.url.navigate(returnUrl ? returnUrl : backPath);
    }
  };
  return React.createElement("div", {
    className: "padding-1 navigation-back-".concat(brand, " u-flex u-flex-align-items-center")
  }, React.createElement(IconButton, {
    className: "u-flex u-flex-align-items-center",
    onClick: handleOnClick
  }, React.createElement(Icon, {
    icon: "arrow-left"
  }), React.createElement("span", {
    className: "margin-left-1 fc-navy f-500"
  }, match.text)), React.createElement("span", {
    className: "f-500 bold"
  }, breadcrum));
};
setGlobal('svs.tur.NavigationBack', NavigationBack);

 })(window);